import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
export const frontmatter = {
  "title": "Financiación",
  "lead": "Uno de cada tres países no cumple ninguno de los principales objetivos de referencia sobre financiación para los gobiernos esbozados en el Marco de Acción de Educación 2030."
};
function _createMdxContent(props) {
  const _components = {
    a: "a",
    blockquote: "blockquote",
    h2: "h2",
    li: "li",
    p: "p",
    strong: "strong",
    ul: "ul",
    ..._provideComponents(),
    ...props.components
  }, {Figure, HighlightByIndex, HighlightByPalette, IndicatorReference, RelatedMaterial, ScrollyArea, ScrollySection, ScrollySticky} = _components;
  if (!Figure) _missingMdxReference("Figure", true);
  if (!HighlightByIndex) _missingMdxReference("HighlightByIndex", true);
  if (!HighlightByPalette) _missingMdxReference("HighlightByPalette", true);
  if (!IndicatorReference) _missingMdxReference("IndicatorReference", true);
  if (!RelatedMaterial) _missingMdxReference("RelatedMaterial", true);
  if (!ScrollyArea) _missingMdxReference("ScrollyArea", true);
  if (!ScrollySection) _missingMdxReference("ScrollySection", true);
  if (!ScrollySticky) _missingMdxReference("ScrollySticky", true);
  return _jsxs(_Fragment, {
    children: [_jsx(Figure, {
      id: "HERO_FINANCE"
    }), "\n", _jsxs(_components.blockquote, {
      children: ["\n", _jsx(_components.p, {
        children: "Las ambiciosas metas que marcan los ODS en materia de educación no se alcanzarán a menos que se inviertan recursos adicionales, especialmente en los países más rezagados."
      }), "\n"]
    }), "\n", _jsx(_components.p, {
      children: "El informe GEM calcula que, para conseguir de aquí a 2030 la meta de la educación básica universal (es decir, educación preescolar, primaria y secundaria) los países de ingreso bajo y mediano bajo deben invertir 461 mil millones de dólares estadounidenses.Es poco probable que muchos países aumenten adecuadamente sus presupuestos debido a los bajos ingresos fiscales, lo que se traduce en un déficit de financiación anual estimado en 97.000 millones de USD (el 21% del coste total) para alcanzar los objetivos nacionales entre 2023 y 2030. El déficit medio es de 26 000 millones USD (50% del total) en los países de renta baja y de 71 000 millones USD (17%) en los países de renta media-baja, lo que equivale al 2,3% del PIB durante este periodo."
    }), "\n", _jsx(IndicatorReference, {
      id: "4.5.3",
      children: _jsx(_components.p, {
        children: "Pero un incremento de los recursos no tiene por qué ser suficiente, pues países con niveles de gasto similares en términos de renta per cápita pueden obtener resultados educativos diametralmente opuestos dependiendo de la eficacia, la eficiencia y la equidad del gasto. Por ejemplo, de los 78 países de ingreso mediano y bajo sobre los que se dispone de información, solo 17 (es decir, 1 de cada 5) prestaron una atención significativa a la equidad en sus políticas de financiación, en gran medida países de ingreso mediano alto y de América Latina."
      })
    }), "\n", _jsxs(_components.p, {
      children: ["Las tres principales fuentes de gasto en educación son los gobiernos, los hogares y los donantes. Esta página se centrará en los dos primeros. Se dedica una página aparte a ", _jsx(_components.a, {
        href: "https://www.education-progress.org/es/articles/finance-aid",
        children: "la ayuda a la educación"
      }), "."]
    }), "\n", _jsxs(ScrollyArea, {
      children: [_jsx(ScrollySticky, {
        children: _jsx(Figure, {
          id: "TOTBYSOURCE"
        })
      }), _jsx(ScrollySection, {
        id: "absolute,0",
        children: _jsx(_components.p, {
          children: "En 2022, de los 5.8 billones de dólares estadounidenses de gasto en educación en todo el mundo, solo el 0,45% pertenece al gasto de los países de ingreso bajo, mientras que el 64% pertenece al de los países de ingreso alto. Los dos grupos, sin embargo, presentan un número aproximadamente similar de niños en edad escolar."
        })
      }), _jsx(ScrollySection, {
        id: "relative,1",
        children: _jsxs(_components.p, {
          children: ["De media en todo el mundo, ", _jsx(HighlightByPalette, {
            palette: "06",
            index: "1",
            children: "los hogares"
          }), " sufragan el 25% del costo de la educación. De hecho, la factura educativa que recae sobre los hogares es más elevada en los países de ingreso mediano bajo (44%) que en los países de ingreso alto (20%)."]
        })
      }), _jsx(ScrollySection, {
        id: "relative,2",
        children: _jsxs(_components.p, {
          children: ["Aunque ", _jsx(HighlightByPalette, {
            palette: "06",
            index: "8",
            children: "los donantes"
          }), " aportan el 12% del gasto total en educación en los países de ingreso bajo..."]
        })
      }), _jsx(ScrollySection, {
        id: "absolute,3",
        children: _jsxs(_components.p, {
          children: ["...las contribuciones de ", _jsx(HighlightByPalette, {
            palette: "06",
            index: "8",
            children: "los donantes"
          }), " representan apenas 0.3% del gasto total en todo el mundo, lo que, en importes absolutos, apenas es perceptible."]
        })
      })]
    }), "\n", _jsx(_components.h2, {
      id: "gasto-público",
      children: "Gasto público"
    }), "\n", _jsxs(IndicatorReference, {
      id: "F.1",
      children: [_jsxs(_components.p, {
        children: ["El ", _jsx(_components.a, {
          href: "https://unesdoc.unesco.org/ark:/48223/pf0000245656",
          children: "Marco de Acción Educación 2030 "
        }), " ha establecido dos objetivos de referencia financieros clave para los gobiernos, que les exhortan a:"]
      }), _jsxs(_components.ul, {
        children: ["\n", _jsx(_components.li, {
          children: "destinar al menos de un 4% a un 6% del PIB a la educación, y/o"
        }), "\n", _jsx(_components.li, {
          children: "destinar al menos de un 15% a un 20% del gasto público a la educación."
        }), "\n"]
      }), _jsx(_components.p, {
        children: "En términos generales, los gobiernos no están muy lejos de dichos objetivos. La mediana del gasto público es del 4,0% del PIB y del 12,6% del gasto público total. Los gobiernos de los países más pobres con poca capacidad para generar recursos internos pero con grandes cohortes de niños tienden a gastar menos en educación como porcentaje del PIB pero más como porcentaje del gasto público total."
      })]
    }), "\n", _jsxs(IndicatorReference, {
      id: "F.2",
      children: [_jsx(_components.p, {
        children: "En África Subsahariana, el gasto público en educación supone el 15,5% del gasto público total, pero solo el 3,5% del PIB. Por el contrario, en Europa y América del Norte se cumple el objetivo financiero de referencia relativo al porcentaje del PIB (4,8%), pero el porcentaje del gasto público destinado a educación es bajo (10,9%)."
      }), _jsx(_components.p, {
        children: "En términos generales, uno de cada tres países con datos recientes no cumple ninguno de los dos objetivos de referencia. Inicie la animación de la evolución de los datos a lo largo de los años y vea cómo ha ido fluctuando el gasto."
      })]
    }), "\n", _jsx(Figure, {
      id: "GOVVGDP"
    }), "\n", _jsx(_components.p, {
      children: "La principal fuente de ingresos de los gobiernos son los impuestos, también en los países de ingreso bajo que reciben un alto porcentaje de sus ingresos a través de subvenciones (es decir, ayuda). En general, la media de ingresos tributarios expresada como porcentaje del PIB es del 14% en los países de ingreso bajo, el 18% en los países de ingreso mediano bajo, el 22% en los países de ingreso mediano alto, y el 33% en los países de ingreso alto. Incluso si, por ejemplo, se diera la misma prioridad a la educación en los presupuestos de todos los países, los países con más impuestos y otros recursos nacionales gastarían más en educación."
    }), "\n", _jsx(_components.p, {
      children: "Ahora bien, la gran diferencia del gasto en educación entre países que, por lo demás, presentan características similares indica que no existe ninguna relación predeterminada al respecto. Algunos países deciden gastar más en educación para conseguir sus objetivos, y debe llamarse la atención sobre los que no lo hacen."
    }), "\n", _jsx(_components.h2, {
      id: "gasto-de-los-hogares",
      children: "Gasto de los hogares"
    }), "\n", _jsx(_components.p, {
      children: "Los hogares destinan una cuantía significativa a la educación de sus hijos; en los países más pobres dicha cuantía es mayor que en los países más ricos."
    }), "\n", _jsx(_components.p, {
      children: "El gasto puede adquirir la forma de tasas de matrícula o de otro tipo, pero también puede ser para bienes y servicios educativos, algunos de los cuales son obligatorios (como los libros de texto) y otros no (como las clases particulares)."
    }), "\n", _jsxs(IndicatorReference, {
      id: "4.5.4",
      children: [_jsx(_components.p, {
        children: "Cuando se uniformizan dichos datos entre países, surgen pruebas inequívocas de la contribución de los hogares al gasto total en educación, lo que puede modificar la forma en la que se interpretan los esfuerzos de los países en materia educativa."
      }), _jsx(_components.p, {
        children: "En los países de ingreso bajo, los hogares dedican menos del 1% de su presupuesto a la educación, limitados por las dificultades económicas. En cambio, los hogares de los países de ingreso mediano bajo destinan a la educación una media del 2,9% y una media no ponderada del 3,6% de su gasto, siendo su distribución del gasto la más amplia de todos los grupos de renta. El elevado nivel de gasto en los países de ingreso mediano bajo sugiere que los hogares se enfrentan a presiones para complementar una financiación pública inadecuada. En los países de ingreso mediano alto, el porcentaje medio del presupuesto familiar dedicado a la educación desciende al 1,5%, con una media no ponderada del 2,3%. Por último, los hogares de los países de ingreso alto dedican a la educación una mediana del 1,3% o una media no ponderada del 1,7%."
      }), _jsxs(ScrollyArea, {
        children: [_jsx(ScrollySticky, {
          children: _jsx(Figure, {
            id: "GOVHH_ABS_REL"
          })
        }), _jsx(ScrollySection, {
          id: "absolute,BDG,FRA",
          children: _jsxs(_components.p, {
            children: ["Por ejemplo, en 2019 ", _jsx(_components.strong, {
              children: "Bangladés"
            }), " presentaba uno de los niveles más bajos de ", _jsx(HighlightByIndex, {
              index: "0",
              children: "gasto público"
            }), " en cuanto a porcentaje del PIB. Sin embargo, si se tenía en cuenta la ", _jsx(HighlightByIndex, {
              index: "1",
              children: "contribución de los hogares"
            }), ", el gasto nacional total de Bangladés en educación en cuanto a porcentaje del PIB era similar al de ", _jsx(_components.strong, {
              children: "Francia"
            }), "."]
          })
        }), _jsx(ScrollySection, {
          id: "absolute,IND,BEL",
          children: _jsxs(_components.p, {
            children: ["El Gobierno de la ", _jsx(_components.strong, {
              children: "India"
            }), " destinó a la educación casi 2,5 ", _jsx(HighlightByIndex, {
              index: "0",
              children: "puntos porcentuales del PIB"
            }), " menos que ", _jsx(_components.strong, {
              children: "Bélgica"
            }), " (la barra azul), pero en términos generales el gasto de la India fue superior al de Bélgica porque sus ", _jsx(HighlightByIndex, {
              index: "1",
              children: "hogares"
            }), " destinaron más de 2.6 puntos porcentuales del PIB a la educación (la barra roja)."]
          })
        }), _jsx(ScrollySection, {
          id: "relative,NGA,LBN,HTI",
          children: _jsxs(_components.p, {
            children: ["El ", _jsx(HighlightByIndex, {
              index: "1",
              children: "porcentaje del gasto total en educación que aportan los hogares"
            }), " asciende a más del 70% en algunos países, incluidos ", _jsx(_components.strong, {
              children: "Nigeria"
            }), ", ", _jsx(_components.strong, {
              children: "Haití"
            }), " y ", _jsx(_components.strong, {
              children: "Líbano"
            }), "."]
          })
        })]
      })]
    }), "\n", _jsx(_components.h2, {
      id: "conclusión",
      children: "Conclusión"
    }), "\n", _jsxs(_components.p, {
      children: ["El equipo del Informe de seguimiento de la educación en el mundo lleva tiempo defendiendo que, para comprender el gasto mundial en educación, se deben examinar conjuntamente las tres fuentes principales de financiación educativa: la financiación pública y privada nacional - discutidas en esta página - y donantes externos, discutidos en la página de ", _jsx(_components.a, {
        href: "https://www.education-progress.org/es/articles/finance-aid",
        children: "ayuda a la educación"
      }), ". Por tanto, se necesitan datos oportunos y coherentes de los países de ingreso bajo y mediano sobre cuánto se está invirtiendo en educación y de qué fuentes procede dicha financiación."]
    }), "\n", _jsx(RelatedMaterial, {
      children: _jsxs(_components.ul, {
        children: ["\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "https://www.unesco.org/gem-report/en/2024efw",
            children: "Education Finance Watch 2024"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "https://en.unesco.org/gem-report/financing-for-equity",
            children: "Unlocking Financing for Equity in Education"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "https://education-profiles.org/",
            children: "Profiles Enhancing Education Reviews (PEER)"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "https://en.unesco.org/gem-report/node/3141",
            children: "COVID-19 is a Serious Threat to Aid to Education Recovery"
          })
        }), "\n"]
      })
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
